import { getTerminalsApi } from "api/common";
import { Vessel } from "interface/vessel";
import { FC, useState } from "react";
import CustomButton from "ui/Button";
import CustomDropDownList from "ui/dropDown";
import { DATE_FORMAT, ICON_NAMES } from "utils/constant";
import { useTranslation } from "react-i18next";
import { VesselRenderItem } from "ui/dropdownItemList/VesselRenderItem";

import { getLandingNoteStatus, LandingNoteFilter } from "api/landingNote";
import DatePickerComponent from "ui/Date";
import { getVesselFilter } from "api/vessel";
import { DropdownRenderItem } from "ui/dropdownItemList";
import { CustomNumberInput } from "ui/Input";

interface CustomProps {
	pageSize: number;
	setFilterOptions: (options: LandingNoteFilter) => void;
	filterOptions: LandingNoteFilter;
	exportAsPDF: () => void;
	exportAsExcel: () => void;
	isMobileView: boolean;
	handleShowSelectedIds: () => void;
}
const Filter: FC<CustomProps> = ({
	setFilterOptions,
	filterOptions,
	exportAsPDF,
	...props
}) => {
	const { t } = useTranslation();
	const [tempFilter, setTempFilter] = useState<LandingNoteFilter>();

	const applyNoteNumber = () => {
		const newValue = tempFilter?.noteNumber || null;
		const currentValue = filterOptions.noteNumber || null;
		if (newValue === currentValue) return;
		setFilterOptions({
			...filterOptions,
			noteNumber: newValue,
			take: props.pageSize,
			skip: 0,
		});
	};

	const applyFromDate = () => {
		const newValue = tempFilter?.fromDate;
		if (newValue === undefined || newValue === filterOptions.fromDate) return;
		setFilterOptions({
			...filterOptions,
			fromDate: newValue,
			take: props.pageSize,
			skip: 0,
		});
	};

	const applyToDate = () => {
		const newValue = tempFilter?.toDate;
		if (newValue === undefined || newValue === filterOptions.toDate) return;
		setFilterOptions({
			...filterOptions,
			toDate: newValue,
			take: props.pageSize,
			skip: 0,
		});
	};

	const handleVessel = (vessel: Vessel) => {
		setFilterOptions({
			...filterOptions,
			vesselId: vessel.id,
			vesselName: vessel.id ? vessel.nm : "",
			vesselRegistrationNumber: vessel.id ? vessel.rn : "",
			take: props.pageSize,
			skip: 0,
		});
	};
	//console.log("is mbile view", props.isMobileView);
	return (
		<div className="filter-container">
			<div
				className={`filter-items   ${props.isMobileView ? "landing-note-filter-items" : ""}`}
			>
				<div style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder={t("FromDate")}
						label={t("FromDate")}
						className="height-inherit"
						style={{ width: "100%" }}
						format={DATE_FORMAT}
						value={tempFilter?.fromDate !== undefined ? tempFilter.fromDate : filterOptions.fromDate}
						onChange={(e) =>
							setTempFilter({ ...tempFilter, fromDate: e.target.value })
						}
						onBlur={() => applyFromDate()}
					/>
				</div>
				<div style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder={t("ToDate")}
						label={t("ToDate")}
						className="height-inherit"
						style={{ width: "100%" }}
						format={DATE_FORMAT}
						value={tempFilter?.toDate !== undefined ? tempFilter.toDate : filterOptions.toDate}
						onChange={(e) =>
							setTempFilter({ ...tempFilter, toDate: e.target.value })
						}
						onBlur={() => applyToDate()}
					/>
				</div>
				<div style={{ width: "170px" }}>
					<CustomDropDownList
						data={[]}
						filterable={true}
						dataItemKey="id"
						textField="nm"
						label={t("Vessel")}
						value={{
							id: filterOptions.vesselId || null,
							nm: filterOptions.vesselName || " ",
						}}
						itemRender={VesselRenderItem()}
						defaultItem={{ id: null, nm: t("All") }}
						onSelect={handleVessel}
						serverFilter={true}
						serverFilterApi={getVesselFilter}
					/>
				</div>

				<div style={{ width: "170px" }}>
					<CustomDropDownList
						onSelect={(terminal) =>
							setFilterOptions({
								...filterOptions,
								terminalCode: terminal.code,
								terminal: terminal.name,
								take: props.pageSize,
								skip: 0,
							})
						}
						data={[]}
						value={{
							code: filterOptions.terminalCode || null,
							displayName: filterOptions.terminal || " ",
						}}
						itemRender={DropdownRenderItem}
						dataItemKey="code"
						textField="displayName"
						label={t("Terminal")}
						defaultItem={{ id: null, displayName: t("All") }}
						className="height-inherit"
						filterable={true}
						serverFilter={true}
						serverFilterApi={getTerminalsApi}
					/>
				</div>

				<div style={{ width: "170px" }}>
					<CustomDropDownList
						onSelect={(status) =>
							setFilterOptions({
								...filterOptions,
								statusId: status.id,
								status: status.statusText,
								take: props.pageSize,
								skip: 0,
							})
						}
						data={[]}
						value={{
							id: filterOptions.statusId || null,
							statusText: filterOptions.status || " ",
						}}
						dataItemKey="id"
						textField="statusText"
						label={"Status"}
						defaultItem={{ id: "", statusText: "Empty" }}
						className="height-inherit"
						serverApi={getLandingNoteStatus}
					/>
				</div>
				<div className="purchase-overview-filter-field">
					<CustomNumberInput
						onChange={(e) =>
							setTempFilter({ ...tempFilter, noteNumber: e })
						}
						label={t("LandingNoteNumber")}
						placeholder=" "
						className="height-inherit"
						value={tempFilter?.noteNumber}
						onKeyDown={(e: any) => {
							if (e.key === "Enter") applyNoteNumber();
						}}
						onBlur={(e) => applyNoteNumber()}
						spinners={false}
					/>
				</div>
			</div>

			<div
				className={`filter-end-btn   ${props.isMobileView ? "landing-note-filter-end-btn" : ""}`}
			>
				{/*<CustomButton*/}
				{/*	label={"PDF"}*/}
				{/*	onClick={() => exportAsPDF()}*/}
				{/*	iconName={ICON_NAMES.Download}*/}
				{/*/>*/}
				<CustomButton
					label={"Excel"}
					onClick={() => props.exportAsExcel()}
					iconName={ICON_NAMES.Download}
				/>
				<CustomButton
					label={"CC-streng"}
					onClick={() => props.handleShowSelectedIds()}
					iconName={ICON_NAMES.Copy}
				/>
			</div>
		</div>
	);
};

export default Filter;
